export {
    saveCoach,
    getCoach,
    storePosting,
    getAllPostingsById,
    editPosting,
    updatePosting,
    deletePostingById,
    validataCoachFromDatabase,
} from './coachProfile.service';



// WEBPACK FOOTER //
// ./src/common/services/coachProfile.service/index.js